import { EVENT_LABEL_LOCATION, GA_EVENT_LOGIN, GA_EVENT_SIGN_UP } from '@/constants'
import AnalyticsService from '@/services/analytics'
import { useI18n } from 'vue-i18n-composable'

export enum GaAuthType {
	SignIn = 'login',
	SignUp = 'sign_up'
}

export enum GaAuthMethod {
	Email = 'email',
	Google = 'google'
}

export const useGaAuth = (authType: GaAuthType) => {
	const analytics = new AnalyticsService()
	const { locale } = useI18n()

	const track = ({
		userId,
		authMethod,
		buttonLabel,
		status,
		message
	}: {
		userId: number
		authMethod?: string
		buttonLabel?: string
		status?: string
		message: string
	}) => {
		analytics.sendGa4NewFormatEvent({
			event: `authentication.${authType}`,
			event_label: authType,
			userId: userId,
			lang: locale.value,
			auth_method: authMethod,
			type: authMethod,
			button_label: buttonLabel ?? '',
			status: status ?? '',
			message: message,
			location: EVENT_LABEL_LOCATION.default
		})
	}

	const trackConsentCheckbox = (status: boolean) => {
		track({
			userId: 0,
			buttonLabel: 'checkbox_legal',
			message: '',
			status: status.toString()
		})
	}

	const trackMissingConsents = (authMethod: GaAuthMethod) => {
		track({
			userId: 0,
			authMethod: authMethod,
			status: 'error_consent_missing',
			message: 'Missing terms and conditions, privacy policy'
		})
	}

	const trackSubmitAuth = ({
		userId,
		authMethod,
		isSuccess,
		message
	}: {
		userId?: number
		authMethod: GaAuthMethod
		isSuccess: boolean
		message?: string
	}) => {
		const eventName = authType === GaAuthType.SignIn ? 'user_login' : 'user_sign_up'
		analytics.sendGa4NewFormatEvent({
			event: authType === GaAuthType.SignIn ? GA_EVENT_LOGIN : GA_EVENT_SIGN_UP,
			event_label: eventName,
			userId: userId ?? 0,
			lang: locale.value,
			status: isSuccess ? 'success' : 'fail',
			message: message ?? '',
			location: EVENT_LABEL_LOCATION.default,
			type: authMethod,
			button_label: undefined
		})
	}

	return { trackConsentCheckbox, trackSubmitAuth, trackMissingConsents }
}
